import FocusGauge from './FocusGauge';
export default FocusGauge;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/FocusGauge/index.js